import React from 'react';

// "Recargar" deja una marca para que App.js abra la pantalla segura (Usuario) una vez, en vez del
// módulo que falló (rol usuario y Básico entran a su último módulo, mig 122): así no cae en el mismo ciclo.
export const CLAVE_MENU_SEGURO = 'sih_menu_seguro';

const recargar = () => {
  try { sessionStorage.setItem(CLAVE_MENU_SEGURO, '1'); } catch { /* sin sessionStorage: recarga normal */ }
  window.location.reload();
};

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Error no capturado en la app:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh', display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center', gap: 16,
          fontFamily: "'Segoe UI', Tahoma, sans-serif", backgroundColor: '#f8f9fa',
        }}>
          <h2 style={{ color: '#1a3a6e', margin: 0 }}>Ocurrió un error inesperado</h2>
          <p style={{ color: '#666', margin: 0 }}>Intenta recargar la página. Si el problema persiste, contacta a soporte.</p>
          <button
            onClick={recargar}
            style={{
              padding: '10px 24px', backgroundColor: '#f97316', color: 'white',
              border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 'bold', fontSize: 15,
            }}
          >
            Recargar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
